import { useState } from "react";
const useCurrentLocation = () => {
    const [currentLocation, setCurrentLocation] = useState(null);
    const [error, setError] = useState(null);
    const getUserLocation = () => {
        if (!navigator.geolocation) {
            // prompt the user to enable geolocation.
            setError("Geolocation is not supported by your browser.");
            return;
        }
        navigator.geolocation.getCurrentPosition((position) => {
            console.debug("getUserLocation", position);
            const { latitude, longitude } = position.coords;
            setCurrentLocation({ latitude, longitude });
            setError(null);
        }, (err) => {
            setError("Unable to retrieve your location.");
            console.error(err);
        });
    };
    return { currentLocation, error, getUserLocation };
};
export default useCurrentLocation;
